<span *ngIf="errorMessage" [innerHTML]="errorMessage" class="form-error-message text-danger"></span>

<span *ngIf="saved" [innerHTML]="successMessage" class="form-success-message text-success"></span>
